import React from 'react';
import WhereIsMyString from 'src/components/common/ui/WhereIsMyString';

type Props = Record<string, never>;

const WhereIsMyStringView: React.FC<Props> = (props: Props) => {
  return (
    <div id="wims-view">
      <WhereIsMyString />
    </div>
  );
};

export default WhereIsMyStringView;
